<script setup lang="ts">
/**
 * PaperLetter — a reading written out as a letter: a raised paper sheet held to
 * the page by a strip of cream washi tape. Used by the live reading (SpreadResult)
 * and the saved one (/reading/:id). The text inside gets the letter's airy line
 * height via `.letter-text`.
 */
</script>

<template>
  <article class="paper-sheet-raised relative px-5 pb-6 pt-8">
    <span
      class="letter-tape"
      aria-hidden="true"
    />
    <slot />
  </article>
</template>

<style scoped>
/* Scoped (attribute) specificity beats the unlayered .type-body line-height. */
:slotted(.letter-text) {
  line-height: 1.7;
}
/* A strip of cream washi tape holding the letter to the page. */
.letter-tape {
  position: absolute;
  top: -10px;
  left: 50%;
  width: 92px;
  height: 22px;
  transform: translateX(-50%) rotate(-2.5deg);
  background: var(--paper-grain) repeat, color-mix(in srgb, var(--paper-stock) 82%, transparent);
  clip-path: var(--paper-cut-tape);
  box-shadow: 0 2px 4px var(--paper-shade);
}
</style>
